import React from "react";
import { Grid } from "@material-ui/core";
import { EditProfileAvatar } from "../../author/edit-profile/edit-profile-avatar";
import { StyledInput } from "../../form/input";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Colors } from "../../../theme/colors";
import {StyledSelect} from "../../form/select";
import {mainCategories} from "../../../data/main-categories";
import {BoxWrapper} from "../../box-wrapper/box-wrapper";
import {Categories} from "../../categories";
import {CountryAutocomplete} from "../../form/country-autocomplete";
import {StyledCheckbox} from "../../form/checkbox";
import {newMainCategories} from "../../../data/new-main-categories";


export const EditProfileFormStep1: React.FC<Props> =
	({
		initialPhoto,
		handleFile,
		handleChange,
		setFieldValue,
		values,
		errors,
		touched
	}) => {
		const { t } = useTranslation(['publisher', 'common']);

		return <>
			<Grid container direction="row" spacing={1} style={{'marginBottom': '30px'}}>
				<Grid item sm={12} md={6} container direction="column">
					<StyledTitle>{t('editProfile.step1Title')}</StyledTitle>
					<Grid item container direction="column" spacing={1}>
						<Grid item>
							<EditProfileAvatar
								initialImage={initialPhoto}
								handleImage={handleFile}
							/>
						</Grid>
						{/*<StyledAccountType className={(errors.publisherType && touched.publisherType) ? 'error' : ''}>*/}
						{/*	{t('editProfileFirstTime.accountType')}**/}
						{/*</StyledAccountType>*/}
						{/*<Grid container direction="row">*/}
							{/*<Grid item>*/}
							{/*	<StyledCheckbox*/}
							{/*		id={"publisherType"}*/}
							{/*		name={"publisherType"}*/}
							{/*		onChange={handleChange}*/}
							{/*		value={values.publisherType}*/}
							{/*		label={t('common:publisher')}*/}
							{/*	/>*/}
							{/*</Grid>*/}

							{/*<Grid item>*/}
							{/*	<StyledCheckbox*/}
							{/*		id={"agencyType"}*/}
							{/*		name={"agencyType"}*/}
							{/*		onChange={handleChange}*/}
							{/*		value={values.agencyType}*/}
							{/*		label={t('common:agency')}*/}
							{/*	/>*/}
							{/*</Grid>*/}
						{/*</Grid>*/}
						<Grid item>
							<StyledInput
								id="nip"
								label={t('editProfile.form.taxNumber') + "*"}
								onChange={handleChange}
								value={values.nip}
								error={errors.nip && touched.nip}
							/>
						</Grid>
						<Grid item>
							<StyledInput
								id="name"
								label={t('editProfile.form.name') + "*"}
								onChange={handleChange}
								value={values.name}
								error={errors.name && touched.name}
							/>
						</Grid>
						<Grid item>
							<CountryAutocomplete
								values={values}
								multiple={false}
								setFieldValue={setFieldValue}
								fieldName={'country'}
								label={t('editProfile.form.country') + "*"}
								error={!!(errors.country && touched.country)}
							/>
						</Grid>
						<Grid item>
							<StyledInput
								id="numberOfBooks"
								label={t('editProfile.numberOfBooks')}
								onChange={handleChange}
								value={values.numberOfBooks}
							/>
						</Grid>
						<Grid item>
							<StyledInput
								id="averageNumberOfBooks"
								label={t('editProfile.averageNumberOfBooks')}
								onChange={handleChange}
								value={values.averageNumberOfBooks}
							/>
						</Grid>
					</Grid>
				</Grid>

				<Grid item sm={12} md={6} container direction="column">
					<StyledTitle>{t('editProfile.step6Title')}</StyledTitle>
					<Grid item container direction="column" spacing={2}>
						<Grid item style={{maxWidth: '100%'}}>
							<StyledSelect
								id={'mainCategory'}
								label={t('editProfile.form.mainCategory') + "*"}
								onChange={handleChange}
								value={values.mainCategory}
								options={newMainCategories}
								optionsLabel={(option) => t('common:mainCategories.' + option)}
								error={errors.mainCategory && touched.mainCategory}
							/>
						</Grid>

						{values.mainCategory &&
                            <Grid item style={{maxWidth: '100%'}}>
                                <BoxWrapper title={t('editProfile.form.categories') + "*"}>
									{errors.categories && touched.categories &&
                                        <StyledErrorP>{t('editProfile.form.categoriesError')}</StyledErrorP>
									}
                                    <Categories
                                        selectedCategory={values.categories}
                                        mainCategory={values.mainCategory}
                                        handleSelectedCategory={(selectedCategory) => {
											setFieldValue('categories', selectedCategory);
										}}
                                    />
                                </BoxWrapper>
                            </Grid>
						}
					</Grid>
				</Grid>
			</Grid>

		</>;
	}

interface Props {
	initialPhoto: string;
	handleFile: any;
	handleChange: any;
	setFieldValue: any;
	values: any;
	errors: any;
	touched: any;
}

const StyledTitle = styled('p')`
  color: ${Colors.lightViolet};
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 1rem;
`;

const StyledErrorP = styled('p')`
  color: #f44336;
  margin-top: -5px;
  margin-bottom: 10px;
`;

const StyledAccountType = styled('p')`
  color: ${Colors.violet};
  font-weight: 500;
  font-size: 0.9rem;
  
  &.error {
    color: #f44336;
  }
`;
